import {request} from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";
import CONFIG from '../config';
import axios from 'axios';
import {getToken} from '../base/HTTP';

/**
 * Create a new criminal record declaration
 * @param {Object} data - Criminal record declaration data
 * @returns {Promise}
 */
export async function createCriminalRecordDeclaration(data) {
    return await request('/api/CriminalRecordDeclaration', data, HttpMethod.POST);
}

/**
 * Get criminal record declaration by ID
 * @param {number} id - Declaration ID
 * @returns {Promise}
 */
export async function getCriminalRecordDeclaration(id) {
    return await request(`/api/CriminalRecordDeclaration/${id}`, {}, HttpMethod.GET);
}

/**
 * Get criminal record declaration by Application ID
 * This function handles 404 responses gracefully since a 404 is expected when no declaration exists yet.
 * @param {number} applicationId - Application ID
 * @returns {Promise}
 */
export async function getCriminalRecordDeclarationByApplicationId(applicationId) {
    try {
        // Use axios directly to bypass the HTTP interceptor that redirects on 404
        // This allows us to handle 404 as a valid response (no declaration exists yet)
        const response = await axios.get(
            `${CONFIG.baseUrl}/api/CriminalRecordDeclaration/application/${applicationId}`,
            {
                headers: {
                    'Authorization': getToken(),
                    'Accept': 'application/json'
                },
                validateStatus: function (status) {
                    // Don't throw error for 404 - it's expected when no declaration exists
                    return status >= 200 && status < 500;
                }
            }
        );

        // Return response in the same format as the request function
        if (response.status === 404) {
            return {
                ok: false,
                status: 404,
                data: null
            };
        }

        return {
            ok: response.status >= 200 && response.status < 300,
            status: response.status,
            data: response.data
        };
    } catch (error) {
        // If it's a 404, return a proper response object (shouldn't reach here with validateStatus)
        if (error.response && error.response.status === 404) {
            return {
                ok: false,
                status: 404,
                data: null
            };
        }
        // Re-throw other errors
        throw error;
    }
}

/**
 * Update criminal record declaration
 * @param {number} id - Declaration ID
 * @param {Object} data - Updated declaration data
 * @returns {Promise}
 */
export async function updateCriminalRecordDeclaration(id, data) {
    return await request(`/api/CriminalRecordDeclaration/${id}`, data, HttpMethod.PUT);
}

/**
 * Mark email as sent
 * @param {number} id - Declaration ID
 * @param {string} emailTo - Email address
 * @returns {Promise}
 */
export async function markEmailAsSent(id, emailTo) {
    return await request(`/api/CriminalRecordDeclaration/${id}/email-sent`, emailTo, HttpMethod.PUT);
}
